module.exports = __webpack_public_path__ + "img/fk.cf221ea3.svg";